import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col space-x-1" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex flex-col mt-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode(" Intitulé du règlement de la dépense "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_5 = { class: "flex flex-col mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Montant a regler "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_7 = { class: "flex flex-row items-end justify-end w-full space-x-4" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpenseSettleModal',
  props: {
    open: { type: Boolean },
    name: {},
    isLoading: { type: Boolean },
    settleData: {}
  },
  emits: ["close", "update:label", "update:paid_amount", "submit"],
  setup(__props: any) {

	/**
	 * Expense settlement modal — extracted from ExpenseManagement.vue.
	 * Handles a single payment installment against an anticipated expense.
	 */
	
	

return (_ctx: any,_cache: any) => {
  const _component_InputTag = _resolveComponent("InputTag")!
  const _component_ButtonTag = _resolveComponent("ButtonTag")!
  const _component_ModalPage = _resolveComponent("ModalPage")!

  return (_ctx.open)
    ? (_openBlock(), _createBlock(_component_ModalPage, {
        key: 0,
        title: 'Règlement de la dépense',
        name: _ctx.name,
        styleContent: "w-full",
        styleFooter: "w-full",
        styleModal: '!w-2/6',
        onClose: _cache[4] || (_cache[4] = (e) => _ctx.$emit('close', e))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_InputTag, {
                  placeholder: "Ex : Règlement tranche 1 de la dépense au carburant",
                  type: "text",
                  value: _ctx.settleData.label,
                  onModel: _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:label', e))
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_InputTag, {
                  placeholder: "Ex : 346 000",
                  type: "number",
                  onModel: _cache[1] || (_cache[1] = (e) => _ctx.$emit('update:paid_amount', e)),
                  value: _ctx.settleData.paid_amount
                }, null, 8, ["value"])
              ])
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ButtonTag, {
              label: "Annuler",
              activeIcon: false,
              icon: "/media/icons/add-icon.svg",
              css: "bg-gray-500 border-secondary text-white px-6 py-2 hover:bg-gray-600 w-full active:bg-gray-500 focus:outline-none",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close', _ctx.name)))
            }),
            _createVNode(_component_ButtonTag, {
              label: "Enregistrer",
              activeIcon: false,
              loader: _ctx.isLoading,
              "text-loading": 'Règlement en cours...',
              css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152] focus:outline-none",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('submit')))
            }, null, 8, ["loader"])
          ])
        ]),
        _: 1
      }, 8, ["name"]))
    : _createCommentVNode("", true)
}
}

})